import * as React from 'react';
import { TextItem, LinkItem } from '../../../../components/VillageAddingBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export var renderItem = function renderItem(item) {
  switch (item.type) {
    case 'text':
      return /*#__PURE__*/_jsx(TextItem, {
        value: item.value
      });
    case 'link':
      return /*#__PURE__*/_jsx(LinkItem, {
        value: item.value,
        href: item.href
      });
    default:
      return null;
  }
};